export default "__VITE_ASSET__DvwEcjet__"